exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ledger-tab[data-v-cbd4ff16]{left:-45px}.ledger-tab[data-v-cbd4ff16],.ledger-tab .ledger-tab-item[data-v-cbd4ff16]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ledger-tab .ledger-tab-item[data-v-cbd4ff16]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:40px;height:100px;padding:0 10px;margin-bottom:20px;text-align:center;background-color:#2a4e51;color:#fff;font-size:14px;cursor:pointer}.ledger-tab .active[data-v-cbd4ff16]{color:#9aeaff}", ""]);

// exports
